import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";

interface EarningClaimsProps {
    extraControles: React.ReactNode[];
}

const EarningClaims = ({ extraControles }: EarningClaimsProps) => {

    const config: MasterConfigs = {
        api: () => '',
        title: 'Earning Claims',
        modalTitle: (action) => `${action} Earning Claim`,
        extraControles: [
            ...extraControles
        ],
        getColumns: () => [
            {
                title: 'Component Type',
                dataIndex: 'componentType',
                key: 'componentType'
            },
            {
                title: 'Component Name',
                dataIndex: 'componentName',
                key: 'componentName'
            },
            {
                title: 'Comment',
                dataIndex: 'comment',
                key: 'comment'
            },
            {
                title: 'Claimed Date',
                dataIndex: 'claimedDate',
                key: 'claimedDate'
            },
            {
                title: 'Slip',
                dataIndex: 'slip',
                key: 'slip'
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status'
            },
            {
                title: 'Approver',
                dataIndex: 'approver',
                key: 'approver'
            },
            {
                title: 'Action',
                dataIndex: 'action',
                key: 'action'
            }
        ],
        getFormColumns: () => [
            {
                label: 'Claim Type',
                name: 'claimType',
                type: 'select',
                rules: [
                    {
                        required: true,
                        message: "Please select a claim type"
                    }
                ]
            },
            {
                type: 'form',
                name: 'claimType',
                label: 'Claim Type',
                span: 24,
                form: [
                    {
                        label: "Claim Title",
                        name: "claimTitle",
                        type: "text",
                        rules: [
                            {
                                required: true,
                                message: "Please enter a claim title"
                            }
                        ],
                        span: 8,
                    },
                    {
                        label: "Amount",
                        name: "amount",
                        type: "text",
                        rules: [
                            {
                                required: true,
                                message: "", // suppress default message, only shows star
                            },
                            {
                                validator: async (_, value) => {
                                    const trimmed = value?.toString().trim();

                                    if (!trimmed) {
                                        return Promise.reject("Please enter an amount");
                                    }

                                    if (isNaN(trimmed)) {
                                        return Promise.reject("Please enter a valid number");
                                    }

                                    return Promise.resolve();
                                }
                            }
                        ],
                        span: 8,
                        inputProps: {
                            placeholder: "Enter amount",
                            addonAfter: "INR"
                        }
                    },
                    {
                        label: "Slip",
                        name: "slip",
                        type: "file",
                        span: 8,
                        rules: [
                            {
                                required: true,
                                message: "Please upload a slip"
                            }
                        ],
                        uploadProps: {
                            multiple: false,
                            maxCount: 1,
                            accept: '.png,.jpeg,.jpg,.pdf',
                            listType: 'text',
                        }
                    },
                    {
                        label: "Comment",
                        name: "comment",
                        type: "textarea",
                        span: 16
                    },
                ]
            }
        ],
        actions: [
            { name: 'Add Claim', actionType: 'Add' }
        ]
    }

    return (
        <MasterComponent config={config} />
    )
}

export default EarningClaims;
